
function getFilter(d, clickSelection, connectionChains, hoverSelection,
  iconOpacity, chainSelection, landschapOptions, partijenOptions){


  // grayscale filter
  let grayFilter = '';
  if(
    d.ID !== chainSelection &&
    (
      (
        clickSelection >= 0 &&
        connectionChains[clickSelection]['depthOfIcons'][d.ID] > 2
      ) ||
      (
        clickSelection >= 0 &&
        !(d.ID in connectionChains[clickSelection]['depthOfIcons']) &&
        connectionChains[chainSelection]['chainIcons'].includes(+d.ID)
      ) ||
      (
        hoverSelection >= 0 &&
        connectionChains[hoverSelection]['depthOfIcons'][d.ID] > 2
      )
    )
  ){
    grayFilter = 'grayscale(100%)';
  }

  // blur filter
  let filter = grayFilter;

  if(
    (partijenOptions !== [] || landschapOptions !== []) &&
    iconOpacity !== 0
  ){
    filter = 'opacity(0%)' + grayFilter;

    const iconPartijen = d['betrokken partijen'].split(';').filter(d => d !== '').map(d => d.toUpperCase().replaceAll(' ', ''))
    const iconLandschapstypes = d['landschapstypen (gidsmodel)'].split(';').filter(d => d !== '').map(d => d.toUpperCase().replaceAll(' ', ''))

    if(
      (
        partijenOptions.filter(partij => iconPartijen.includes(partij.toUpperCase())).length > 0 ||
        iconPartijen.length === 0
      ) &&
      (
        landschapOptions.filter(landschap => iconLandschapstypes.includes(landschap.toUpperCase().replace(' ', ''))).length > 0 ||
        (iconLandschapstypes.includes('NEDERLAND') && landschapOptions.length > 0) ||
        iconLandschapstypes.length === 0
      )
    ){
      filter = grayFilter;
    }

  }

  return [filter, iconOpacity];

}

export default getFilter;
